export default () => ({
  hidden: { display: 'none' },
  cardHeaderSubheader: { lineHeight: 1.1 },
});
